import { useQueryClient } from 'react-query';
import { FilterParams } from '../../interfaces/Filter';
import { Transactions } from '../../interfaces/Transactions';
import { useGetQuery } from '../useGetQuery';

const defaultParams: FilterParams = {
    page: 1,
    size: 20
};

export const useTreasuryTransactions = (
    bankId: string | null,
    initialParams?: FilterParams
) => {
    const queryClient = useQueryClient();

    const params = initialParams || defaultParams;
    const url = bankId
        ? `/banks/connect/${bankId}/transactions`
        : `/banks/connected/transactions`;

    const {
        isLoading,
        entries: transactionsList,
        isFetching,
        paging
    } = useGetQuery<{
        page: number;
        limit: number;
        total: number;
        transactions: Transactions[];
    }>({
        url,
        cacheKey: `treasury-transactions-${params?.page}`,
        params: {
            ...params,
            limit: params.size
        }
    });

    const invalidateTransactionsCache = () => {
        queryClient.invalidateQueries({ queryKey: [`treasury-transactions-${params?.page}`, params] });
    };

    return {
        isLoading,
        transactionsList,
        invalidateTransactionsCache,
        isFetching,
        transactionPaging: paging
    };
};
